/**
 * Shared lifecycle field descriptors — mirrors `Activatable` / inactivation.
 * Spread into entity `fields` for every entity that stamps `active` +
 * `inactivationDate` via `lifecycleService` (same mold as `_auditFields.ts`).
 *
 * Labels are pt-BR (console-ui-conventions §7). `description` is code docs and
 * stays in English.
 */
export const LIFECYCLE_FIELD_DESCRIPTORS = [
    {
        name: 'active',
        label: 'Ativo',
        type: 'boolean',
        required: false,
        description: 'Denormalized, queryable active flag (derived from inactivationDate on save)',
    },
    {
        name: 'inactivationDate',
        label: 'Data de inativação',
        type: 'date',
        required: false,
        description: 'Date when the record was inactivated (null if active)',
    },
];
//# sourceMappingURL=_lifecycleFields.js.map